import gsap from "gsap";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(SplitText);

// Banner Animation
function bannerAnimation() {
    // gsap.to(".banner-section", {
    //     yPercent: 100,
    //     ease: "none",
    //     scrollTrigger: {
    //         trigger: ".intro",
    //         start: "top bottom",
    //         end: "top top",
    //         scrub: true,
    //     }
    // })


    const panelContainer = document.querySelector('.panel-container');

    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: panelContainer,
            pin: true,
            pinSpacing: false,
            scrub: true,
            end: "+=100%",
        }
    });


}

// Split Text Animation
function initSplitTexts() {
    if (!document.querySelector('[data-split')) return

    const splits = gsap.utils.toArray('[data-split]')

    splits.forEach((split) => {
        const splitWord = new SplitText(split, {
            type: 'lines',
        })

        gsap.from(splitWord.lines, {
            scrollTrigger: {
                trigger: split,
                start: 'top bottom-=10%',
            },
            y: 100,
            autoAlpha: 0,
            duration: 2,
            delay: 1,
            stagger: 0.3,
            ease: 'power4.out',
        })
    })
}

// Key Statistics Animation
function keyAnimation() {
    gsap
    .timeline({
    scrollTrigger: {
      trigger: ".key-statistics",
      start: "top 65%",
      end: "bottom top",
      toggleActions: "play none none none",
    },
    paused: true,
    scrub: true
  })

  .from(
    "[data-gsap=report-number]",
    {
      autoAlpha: 0,
      yPercent: 20,
      ease: "power4.inOut",
      stagger: 0.2,
      duration: 1,
    },
    "<+=.6"
  )
    .from(
    "[data-gsap=report-number] div",
    {
      autoAlpha: 0,
      yPercent: 20,
      ease: "power4.inOut",
      stagger: 0.2,
      duration: 1,
    },
    "<+=.6"
  )
    .from(
    "[data-gsap=report-number] p",
    {
      autoAlpha: 0,
      yPercent: 20,
      ease: "power4.inOut",
      stagger: 0.2,
      duration: 1,
    },
    "<+=.2"
  );
}

// Career Box Hover
function careerBoxHover() {
    const careerBoxItems = document.querySelectorAll('.career-box-item');
    
    careerBoxItems.forEach(item => {
        item.addEventListener('mouseenter', function() {
            // Remove active class from all items
            careerBoxItems.forEach(box => box.classList.remove('active'));
            // Add active class to current hovered item
            this.classList.add('active');
        });
    });
}






export default function runAnimations() {
    bannerAnimation();
    initSplitTexts();
    keyAnimation();
    careerBoxHover();
}
